export type BaseAddress = {
  Address: string;
  body: string;
};

export type NoOutage = 'без отключения';
/**
 * Строка формата YYYY-MM-DD
 */
type OutageDate = string;
type Outage = OutageDate | NoOutage | null;

export type AddressWithUnom = {
  id: string;
  UNOM: string;
  OutageBegin: Outage;
  OutageEnd: Outage;
  residential: boolean;
  BuildingType: string;
  Porches: string;
} & BaseAddress;

export type Address = BaseAddress | AddressWithUnom;

export type AddressResponse = {
  suggests: Address[];
};

export enum AddressRequestStatus {
  Initial = 'Initial',
  Fetching = 'Fetching',
  Success = 'Success',
  Error = 'Error',
}
